var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.pageContent ? _c('div', {
    staticClass: "detail-pages display-grid gap-10"
  }, [_vm.deviceType.isDesktop ? _c('div', {
    staticClass: "detail-pages-title px-20 px-lg-0 display-none display-lg-block"
  }, [_c('h1', {
    staticClass: "typo-h1 mb-0"
  }, [_vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-pages-content"
  }, [_c('div', {
    staticClass: "content-wrapper px-20 px-md-30 px-lg-0"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pageContent)
    }
  })])])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }